import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormioModule } from 'angular-formio';
import { FormsModule } from '@angular/forms';
import { CommonService } from './services/common.service';
import { AuthService } from './services/auth.service';
import { HttpInterceptorService } from './services/http-interceptor.service';
import { CalendarModule } from 'ion2-calendar';
import { ReinitService } from './services/reinit.service';
import { AppTranslateModule } from './translate.module';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    FormioModule,
    FormsModule,
    CalendarModule,
    AppTranslateModule
  ],
  providers: [
    AuthService,
    CommonService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
    ReinitService
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
